import { render, staticRenderFns } from "./QuestionsEdit.vue?vue&type=template&id=be2c0cde&"
import script from "./QuestionsEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports